import { motion } from 'framer-motion'
import styled from 'styled-components'

export const StDotContainer = styled.div`
  padding: ${({ theme }) => theme.UI.Spacing.Space2}px;
  cursor: pointer;
`

export const StDot = styled.div`
  width: ${({ theme }) => theme.UI.Spacing.Space2}px;
  height: ${({ theme }) => theme.UI.Spacing.Space2}px;
  background: ${({ theme }) => theme.Colors.Neutrals.Light};
  border-radius: 50%;
  position: relative;
`

export const StDotHighlight = styled(motion.div)`
  background: ${({ theme }) => theme.Colors.Neutrals.Darker};
  border-radius: 100px;
  width: ${({ theme }) => theme.UI.Spacing.Space2}px;
  height: ${({ theme }) => theme.UI.Spacing.Space2}px;
  position: absolute;
  z-index: 1000;
`
